
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  if (!header) return;

  const dropdown = header.querySelector(".header__products-dropdown");
  if (!dropdown) return;

  const triggers = header.querySelectorAll(
    ".header__products-dropdown-toggle[data-menu-target]"
  );

  const panels = dropdown.querySelectorAll("[data-menu-panel]");

  function closeMenus() {
    dropdown.classList.remove("is-open", "is-haute-open");
    panels.forEach(function (panel) {
      panel.classList.remove("is-active");
    });
    document.documentElement.classList.remove("no-scroll");
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const target = trigger.getAttribute("data-menu-target");

        const panel = Array.from(panels).find(function (item) {
          return item.getAttribute("data-menu-panel") === target;
        });

        if (!panel) return;

        const wasOpen =
          dropdown.classList.contains("is-open") &&
          panel.classList.contains("is-active");

        closeMenus();

        if (!wasOpen) {
          dropdown.classList.add("is-open");
          panel.classList.add("is-active");
          document.documentElement.classList.add("no-scroll");
        }
      },
      true
    );
  });

  dropdown.addEventListener("click", function (event) {
    const link = event.target.closest("a[href]");

    if (link) {
      closeMenus();
    }
  });

  window.addEventListener("pageshow", function () {
    closeMenus();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeMenus();
    }
  });
});
